
import '../App.css';
import Header from '../components/Header';
import VisionMission from '../components/VisionMission';
import Footer from '../components/Footer';
function App() {
  return (
    <div className="App">

    <Header/> 
   
    <VisionMission/>
    <Footer/>
    </div>
  );
}

export default App;
